import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdSortableHeader } from 'src/app/shareModule/directive/ngbd-sortable-header/ngbd-sortable-header.directive';
import { Member } from './admin-manage-survey.model';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-manage-survey',
  templateUrl: './admin-manage-survey.component.html',
  styleUrls: ['./admin-manage-survey.component.scss'],
})
export class AdminManageSurveyComponent implements OnInit {
  public totalActiveUsers: number = 0;
  public totalReferrals: number = 0;
  public page = 1;
  public pageSize = 10;
  public dataFiles: any = [];
  public file: any = null
  fileName = 'Choose file'
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  public survey: any = {
    question: '',
    option: [],
    type: 'checkbox'
  }

  /**
   * Constructor
   */
  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private local: LocalServiceService
  ) { }

  ngOnInit(): void {
    this.initData();
  }

  /**
   * get member details based on created date - dateCreated
   */
  async initData() {
    this.auth.survey_fetch().subscribe((resp: any) => {
      this.dataFiles = resp.body
    })
  }

  addSurvey(isFile = false) {
    if (!this.survey.question.trim()) {
      this.toastr.error("Question is required");
      return;
    }

    if (this.survey.type != 'text' && this.survey.option.length < 1) {
      this.toastr.error("Option is required");
      return;
    }

    // if (isFile && !this.file) {
    //   this.toastr.error("File is required");
    //   return;
    // }

    const formData = new FormData()
    formData.append('question', this.survey.question)
    formData.append('type', this.survey.type)
    formData.append('option', JSON.stringify(this.survey.option))

    this.local.alertLoading({})
    this.auth.survey_add(formData).subscribe(() => {
      Swal.close()
      this.modalService.dismissAll()
      this.toastr.success("SUCCESS")
      this.initData()
      Swal.close()
    }, (e) => {
      this.toastr.error("FAILED")
      Swal.close()
    })
  }

  openAddSurveyModal(modal: any, item: any = null) {
    this.survey = {
      question: '',
      option: [],
      type: 'checkbox'
    }
    this.file = null
    this.modalService.dismissAll();
    this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title' });

    if (item) {
      this.survey = item
      this.survey.option = JSON.parse(item.option)
    }
  }

  onFileChange(event: any) {
    this.file = null
    if (event.target.files && event.target.files.length > 0) {
      this.file = event.target.files[0];
      this.fileName = this.file.name; // Update the fileName with the selected file name
    } else {
      this.fileName = 'Choose file'; // Reset to default if no file is selected
    }
  }

  handleDelete(value: any) {
    this.local.alertConfirm({
      message: `Are you sure want to delete ${value.question} ?`
    }).then((resp) => {
      if (resp.isConfirmed) {
        this.local.alertLoading({})
        this.auth.survey_delete(value.id).subscribe((resp) => {
          this.initData()
          this.toastr.success("SUCCESS")
          Swal.close()
        }, (e) => {
          this.toastr.error("FAILED")
          Swal.close()
        })
      }
    })
  }
}
